import cn from 'classnames';
import { genericMemo } from '@direct-frontend/stdlib';
import { type TreeRow, type TreeSize } from '../../../../lib/types';
import styles from './LevelBlank.module.css';

export interface LevelsBlankProps<Attributes> {
    node: TreeRow<Attributes>;
    size: TreeSize;
}

export const LevelsBlank = genericMemo(function LevelsBlank<Attributes = unknown>({
    node,
    size,
}: LevelsBlankProps<Attributes>) {
    return (
        <>
            {node.rendersBefore.map((parent, index, arr) => (
                <div
                    key={parent.id}
                    className={cn(styles.space, styles.before, {
                        [styles.sizeM]: size === 'm',
                        [styles.nextline]: parent.vertical,
                        [styles.arrow]: index === arr.length - 1,
                    })}
                />
            ))}
        </>
    );
});
